import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';

import { TimerService } from '../../../../../../services/timer.service';
import { TestNavigationService } from '../../../../../../services/test-navigation.service';

@Component({
    selector: 'auto-skip-timer',
    template: require('./auto-skip-timer.component.html'),
})
export class AutoSkipTimerComponent implements OnInit, OnDestroy {
    @Input() time: number;

    counter: number;
    timerSubscription: Subscription;

    constructor(
        private testNavigationService: TestNavigationService,
        private timerService: TimerService
    ) {
    }

    ngOnInit() {
        this.counter = this.time;
    }

    ngOnDestroy() {
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/misc/auto-skip-timer/auto-skip-timer.component.ts